// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scopes[data-v-d89597ee]{text-align:center;line-height:50px;margin-bottom:18px}", ""]);
// Exports
module.exports = exports;
